<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Special-Character-Remover-Root',
};
</script>
